import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";


export const fetchAllCompletedTasks = createAsyncThunk(
  'completedTasks/fetchAll',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get("/projectCompletedTask/completed-tasks");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const fetchTasksByQuotationId = createAsyncThunk(
  'completedTasks/fetchByQuotationId',
  async (quotationId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/projectCompletedTask/project/${quotationId}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const addCompletedTask = createAsyncThunk(
  'completedTasks/add',
  async (taskData, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/projectCompletedTask/completed-tasks", taskData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateCompletedTask = createAsyncThunk(
  'completedTasks/update',
  async ({ id, updatedData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`/projectCompletedTask/${id}`, updatedData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteCompletedTask = createAsyncThunk(
  'completedTasks/delete',
  async (id, thunkAPI) => {
    try {
      await axiosInstance.delete(`/projectCompletedTask/${id}`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const projectCompletedTasksSlice = createSlice({
  name: 'completedTasks',
  initialState: {
    tasks: [],
    completeTask:[],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchAllCompletedTasks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllCompletedTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.completeTask = action.payload;
      })
      .addCase(fetchAllCompletedTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchTasksByQuotationId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTasksByQuotationId.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks = action.payload;
      })
      .addCase(fetchTasksByQuotationId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addCompletedTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCompletedTask.fulfilled, (state, action) => {
        state.loading = false;
        state.tasks.unshift(action.payload);
      })
      .addCase(addCompletedTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateCompletedTask.fulfilled, (state, action) => {
        const index = state.tasks.findIndex(task => task._id === action.payload._id);
        if (index !== -1) state.tasks[index] = action.payload;
      })
      .addCase(updateCompletedTask.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deleteCompletedTask.fulfilled, (state, action) => {
        state.tasks = state.tasks.filter(task => task._id !== action.payload);
      })
      .addCase(deleteCompletedTask.rejected, (state, action) => {
        state.error = action.payload;
      });
  }
});

export default projectCompletedTasksSlice.reducer;
